// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"index_cardBox__2X-v_","title":"index_title__1s3Qj","tip":"index_tip__28gGA"};